import {
  PLACE_ORDER_REQUEST,
  PLACE_ORDER_SUCCESS,
  PLACE_ORDER_FAILURE,
  GET_ORDER_SUCCESS,
} from "../actions/placeOrderAction";

const initialState = {
  loading: false,
  orderData: null,
  orderList: [],
  error: null,
};

const placeOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case PLACE_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case PLACE_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        orderData: action.payload, // contains order confirmation/ID etc.
        error: null,
      };

    case PLACE_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case GET_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        orderList: action.payload, // contains order confirmation/ID etc.
        error: null,
      };

    default:
      return state;
  }
};

export default placeOrderReducer;
